import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const scrumProject = {
    "id": "E187a5",
    "name": "Scrum Project",
    "img": "/app/static/templates/software/scrum-software.jpg",
    "description": "Pre-configured backlog and sprints to run your scrum project.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};


const bugTracker = {
    "id": "8lpiMb",
    "name": "Bug Tracker",
    "img": "/app/static/templates/software/bug-tracker.jpg",
    "description": "Template to record, track, and resolve issues and bugs.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const softwareProject = {
    "id": "j7Bg5w",
    "name": "Generic Application",
    "img": "/app/static/templates/software/application.jpg",
    "description": "Generic software development template.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const mobileDevelopment = {
    "id": "uhR6VP",
    "name": "Mobile Application",
    "img": "/app/static/templates/software/mobile.jpg",
    "description": "Pre-configured structure and workflows focused on mobile apps.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const webApp = {
    "id": "t1YWgx",
    "name": "Web Application",
    "img": "/app/static/templates/software/web-application.jpg",
    "description": "Pre-configured structure and workflows focused on web projects.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const website = {
    "id": "f3D3Q7",
    "name": "Website Development",
    "img": "/app/static/templates/software/website.jpg",
    "description": "Template to manage website projects from planning to launch.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const api = {
    "id": "M3FPQy",
    "name": "REST API",
    "img": "/app/static/templates/software/rest-api.jpg",
    "description": "Structured project with phases for API planning and development.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};

const testing = {
    "id": "hHva6d",
    "name": "Testing / QA",
    "img": "/app/static/templates/it/testing.jpg",
    "description": "Manage QA testing process and test cases with this template.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: 'Software Development',
    demoFolderColor: 20
};



export default {
    id: 'software',
    name: "Software development",
    items: [

        scrumProject,

        softwareProject,

        webApp,
        mobileDevelopment,
        website,
        api,

        bugTracker,
        testing

    ]
};